import React from 'react'

import style from './style.css'

export default class TimelineGroup extends React.Component {

  render() {
    const { children } = this.props
    return (
      <div className={style.timelineGroup}>
        <div className={style.spacer} />
        {children}
      </div>
    )
  }
}
